<template>
  <div>
   <div class="align-items-center justify-content-center" style="min-height: 100vh;">
      <span v-if="model" class="text-left">{{ model.id + ' : ' + model.name }}</span>

      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">{{ $t('message.Добавить_поток') }}</b-button>
      <b-table
        id="stream-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="service_id" slot-scope="row">
          {{ row.item.service.id }}
        </template>
        <template slot="service_name" slot-scope="row">
          {{ row.item.service.name }}
        </template>
        <template slot="service_address" slot-scope="row">
          {{ row.item.service.address }}
        </template>

        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button size="sm" @click.stop="deleteRow(row.item, row.index, $event.target)">
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

      <b-modal
        id="modalStreamEdit"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Поток_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-backdrop
      >
        <StreamForm :model="streamModel"></StreamForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import StreamForm from "./StreamForm";
import Vue from "vue";

export default {
  name: "Streams",
  props: ["model"],
  components: {
    StreamForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "enabled", sortable: false },
        { key: "address", sortable: false },       
        { key: "service_id", sortable: false },
        { key: "service_name", sortable: false },
        { key: "service_address", sortable: false },       
        { key: "actions", label: "", tdClass: "actions" }
      ],
      streamModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  created() {
      // console.log('create: id=' + this.model.id);
  },
  watch: {
    model: function() {
      // console.log('watch model: id=' + this.model.id);
      this.currentPage = 1;
      this.$root.$emit("bv::refresh::table", "stream-table");
    }
  },
  beforeUpdate() {
      // console.log('beforeUpdate: id=' + this.model.id);
  },
  mounted() {
      // console.log('mounted: id=' + this.model.id);
  },
  methods: {
    dataProvider(ctx) {
      // console.log('dataProvider: id=' + this.model.id);
      if (this.model.id) {
        let promise = this.$noname.getChild("channels", this.model.id, "streams", { params: { currentPage: this.currentPage, perPage: this.perPage} });

        return promise
          .then(data => {
            const items = data.data.items;
            this.totalRows = data.data.total;

            return items;
          })
          .catch(this.$noname.HandleError);
      }
      return [];
    },    
    editRow(item, index, button) {
      this.streamModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalStreamEdit", button);
    },
    deleteRow(item, index, button) {
      this.$dialog.confirm(this.$i18n.t('message.Действительно_удалить_поток?')).then(response => {
        this.$noname
          .delete("streams", item.id)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "stream-table");
            Vue.notify({
              group: "notify",
                text: this.$i18n.t('message.Запись_успешно_удалена'),
              type: "success"
            });
            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
                text: this.$i18n.t('message.Ошибка_удаления_записи') + ':<br>' + error,
              type: "error"
            });
          });
      });
    },
    addRow() {
      // console.log('addRow: 6.id=' + this.model.id);
      this.streamModel = {};
      this.streamModel.channel_id = this.model.id;
      this.$root.$emit("bv::show::modal", "modalStreamEdit");
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.streamModel.id > 0) {
        this.$noname
          .patch("streams", this.streamModel.id, this.streamModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "stream-table");
            this.$root.$emit("bv::hide::modal", "modalStreamEdit");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

    //         //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      } else {
        this.$noname
            .postChild(
              "channels",
              this.streamModel.channel_id,
              "streams",
              this.streamModel
            )

            .then(response => {
            this.$root.$emit("bv::refresh::table", "stream-table");
            this.$root.$emit("bv::hide::modal", "modalStreamEdit");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Запись_успешно_сохранена') ,
              type: "success"
            });

    //         //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t('message.Ошибка_сохранения') + ':<br>'+error ,
              type: "error"
            });
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Streams.vue